import type {
	ClientPropertyCottageDetailResponseDTO,
	ClientPropertyFlatDetailResponseDTO,
	ClientPropertyHouseDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { PropertyOptionalParam } from "web_myplann/Portfolio/Hooks/useGetPropertyOptionalParams";

const PageResources = Resources.PortfolioDetail;

type BuildingDetail =
	| ClientPropertyFlatDetailResponseDTO
	| ClientPropertyHouseDetailResponseDTO
	| ClientPropertyCottageDetailResponseDTO;

export const BUILDING_OPTIONAL_PARAMS: PropertyOptionalParam<BuildingDetail>[] =
	[
		{ key: "terrace", label: PageResources.Property.Terrace },
		{ key: "loggia", label: PageResources.Property.Loggia },
		{ key: "balcony", label: PageResources.Property.Balcony },
		{ key: "garage", label: PageResources.Property.Garage },
		{ key: "cellar", label: PageResources.Property.Cellar },
		{ key: "elevator", label: PageResources.Property.Elevator },
		{ key: "barrierFree", label: PageResources.Property.BarrierFree },
		{ key: "swimmingPool", label: PageResources.Property.SwimmingPool },
		{ key: "parkingSpace", label: PageResources.Property.ParkingSpace },
		{ key: "furnished", label: PageResources.Property.Furnished },
	];
